import React from 'react';
import Select from 'react-select';
import { ReadLotacaoDto } from '@/api.types';
import { SelectOption } from '@/shared/types/selectOption';
import { TipoLotacao } from '../enums/tipo-lotacao.enum';
import { TipoLotacaoList } from '@/shared/constants/enumlist';
import { TipoPessoaLotada } from '../enums/tipo-pessoa-lotada.enum';
import { UseFormGetValues, UseFormRegister } from 'react-hook-form';

interface Props {
  register: UseFormRegister<ReadLotacaoDto>;
  getValues: UseFormGetValues<ReadLotacaoDto>;
  tipoPessoaLotada: TipoPessoaLotada;
  pessoas: SelectOption[];
  refSelectResponsavel: React.Ref<any>;
  handleSelectChange: (selectedOption: SelectOption | null, options: SelectOption[], field: 'responsavel') => void;
}

export const VinculoDadosCard: React.FC<Props> = ({
  register,
  getValues,
  tipoPessoaLotada,
  pessoas,
  refSelectResponsavel,
  handleSelectChange,
}) => {

  return (
    <div className="card">
      <div className="card-header text-center">Dados do Vínculo</div>
      <div className="card-body row">
        <div className="col-md-4" title="Início do período de vínculo.">
          <label htmlFor="data_inicial" className="form-label">
            Início:
          </label>
          <input
            id="data_inicial"
            type="date"
            className="form-control"
            {...register('data_inicial')}
          />
        </div>
        <div className="col-md-4" title="Término do período de vínculo.">
          <label htmlFor="data_final" className="form-label">
            Término:
          </label>
          <input
            id="data_final"
            type="date"
            className="form-control"
            {...register('data_final')}
          />
        </div>

        <div className="col-md-4 mb-4" title="Tipo de vínculo">
          <label htmlFor="tipo" className="form-label">
            Tipo:
          </label>
          <select id="tipo" className="form-select" {...register('tipo')}>
            <>
              {TipoLotacaoList.filter(
                (a) =>
                  (tipoPessoaLotada !== TipoPessoaLotada.Estagiario &&
                    tipoPessoaLotada !== TipoPessoaLotada.Colaborador) ||
                  (tipoPessoaLotada === TipoPessoaLotada.Estagiario &&
                    a.value === TipoLotacao.Designacao) ||
                  (tipoPessoaLotada === TipoPessoaLotada.Colaborador &&
                    a.value === TipoLotacao.Designacao),
              ).map((item) => {
                return (
                  <option key={item.value} value={item.value}>
                    {item.name}
                  </option>
                );
              })}
            </>
          </select>
        </div>

        <div className="col-md-6 mb-4" title="Responsável pelo estagiário.">
          <label htmlFor="responsavel" className="form-label col-md-6">
            Responsável:
          </label>
          <Select
            isDisabled={tipoPessoaLotada !== TipoPessoaLotada.Estagiario}
            id="responsavel"
            ref={refSelectResponsavel}
            isClearable
            defaultValue={pessoas.find((a) => a.value === getValues()?.responsavel?.id)}
            options={pessoas}
            placeholder=""
            onChange={(e) => {
              handleSelectChange(e, pessoas, 'responsavel');
            }}
          />
        </div>

        <div className="col-md-3" title="Início do expediente (opcional).">
          <label htmlFor="entrada" className="form-label">
            Entrada:
          </label>
          <input
            id="entrada"
            type="time"
            className="form-control"
            {...register('entrada')}
          />
        </div>
        <div className="col-md-3" title="Término do expediente (opcional).">
          <label htmlFor="Saida" className="form-label">
            Saída:
          </label>
          <input
            id="Saida"
            type="time"
            className="form-control"
            {...register('saida')}
          />
        </div>

        <div className="form-check mt-3 ms-3 col-md-4" title="Desmarque se for apenas rascunho.">
          <input id="ativo" type="checkbox" className="form-check-input" {...register('ativo')} />
          <label className="form-check-label" htmlFor="ativo">
            Ativo.
          </label>
        </div>

        <div className="form-check mt-3 ms-3 col-md-4" title="Permite ao estagiário marcar qualquer dia em sua folha e não valida se todos os dias foram preenchidos.">
          <input id="diaslivres" type="checkbox" className="form-check-input" {...register('diaslivres')} />
          <label className="form-check-label" htmlFor="diaslivres">
            Dias Livres.
          </label>
        </div>

        <div
          title="Se deve pontuar"
          className="form-check mt-3 col-md-3"
          style={{
            display:
              tipoPessoaLotada === TipoPessoaLotada.Defensor ? 'block' : 'none',
          }}
        >
          <input
            id="pontuar"
            type="checkbox"
            className="form-check-input"
            {...register('pontuar')}
          />
          <label className="form-check-label" htmlFor="pontuar">
            Pontuar.
          </label>
        </div>

        <div
          title="É diretor no caso de vínculo em núcleo."
          className="form-check mt-3 col-md-2"
          style={{
            display:
              tipoPessoaLotada === TipoPessoaLotada.Defensor ? 'block' : 'none',
          }}
        >
          <input
            id="diretor"
            type="checkbox"
            className="form-check-input"
            {...register('diretor')}
          />
          <label className="form-check-label" htmlFor="diretor">
            Diretor(a).
          </label>
        </div>
      </div>
    </div>
  );
};
